import { useEffect } from 'react';

import { Box, Text } from '@nimbus-ds/components';
import { Layout, Page } from '@nimbus-ds/patterns';
import { navigateHeaderRemove } from '@tiendanube/nexo/helpers';

import nexo from '../../nexoClient';
import { AppStatusBar, ConfigButton } from '../../components';

function PageMain() {
  useEffect(() => {
    navigateHeaderRemove(nexo);
  }, []);

  return (
    <Box
      marginX="auto"
      maxWidth={{
        xs: '100%',
        md: '60%',
      }}
    >
      <Page maxWidth="100%">
        <Page.Header
          title="Integração CRM Bônus"
          buttonStack={<ConfigButton />}
        />
        <Page.Body>
          <AppStatusBar />
          <Layout columns="1">
            <Layout.Section>
              <Box display="grid" gap="10"></Box>
            </Layout.Section>
          </Layout>
        </Page.Body>
      </Page>
    </Box>
  );
}

export default PageMain;
